module.exports = __webpack_public_path__ + "static/media/25-8.4f09eb3b.mp3";